import CrudBaseService from "@/services/CrudBaseService";

export default class StudyTypeService extends CrudBaseService {
  constructor() {
    super('odoo/study_type');
  }

  findAllByStudyConfigurationId(studyConfigurationId) {
    return this.http.get(`${this._serviceName}/study-configuration/${studyConfigurationId}`);
  }
}
